@if (control) {
    @if (validationMessages) {
        <lh-validation-messages
            [useDS]="true"
            [showOnSuccess]="showSuccessValidation"
            [formElementRef]="element"
            [formElement]="control"
            [messages]="validationMessages"
            [triggerValidationsOnChange]="triggerValidationsOnChange" />
    }
    @if (showTooltips) {
        <lh-custom-tooltip-messages
            [useDS]="true"
            [formElementRef]="element"
            [formElement]="control"
            [messages]="validationMessages"
            [addInfoTooltips]="additionalTooltips" />
    }
}

<ng-content select="[ptBottom]" />
